// extracted by mini-css-extract-plugin
export var overviewTitleContainer = "blogOverview-module--overviewTitleContainer--4sf7X";
export var overviewContainer = "blogOverview-module--overviewContainer--jZa0y";